import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCrossSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.6 1.6L8.4 8.4M8.4 1.6L1.6 8.4",
		stroke: "currentColor",
		strokeWidth: 1.6,
		strokeLinecap: "round"
	})
});
export default SvgIconCrossSmall;
